exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-4a5b31bb]{width:90%;font-size:.85rem}#info-panel[data-v-4a5b31bb]{background-color:#dee2e6dd}label[for=odf-ratios][data-v-4a5b31bb]:hover{color:#e4454a}a[data-v-4a5b31bb],a[data-v-4a5b31bb]:hover{color:inherit}", ""]);

// exports
